import React, {ReactElement} from "react";
import {TableDataSourceFragmentProps, TableDataSourceFragmentState} from "../../shared/TableDataSourceFragment";
import {PageFragment} from "../../shared/PageFragment";
import {Action, ACTION_OK, ACTION_SPACE, ActionBase, DisplayName} from "../../shared/types";
import {AddOutlined, ContactPageOutlined, DeleteOutlined} from "@mui/icons-material";
import {BaseSelectTableDataRow, TableDataContainer} from "shared/TableDataContainer";
import {TableData} from "../../shared/tabledata";
import {Contact, CONTACT_CHANNEL_KTM, ContactChannel, Contacts} from "./types";
import {EditContactHelper, onManageContact} from "./EditContactHelper";
import {ListTableDataSourceFragment} from "../../shared/ListTableDataSourceFragment";
import {BaseApp} from "../../shared/BaseApp";
import {DateUtil, FORMAT_SHOW_YEAR} from "../../shared/date_util";

class ContactsTableDataRow extends BaseSelectTableDataRow {

  @TableData({
    name: "Channel",
    cellSize: "large",
    type: "enum",
    enumValues: CONTACT_CHANNEL_KTM.kts().values,
    enumColors: CONTACT_CHANNEL_KTM.metadataValues("colorValue").values
  })
  channel: ContactChannel;

  @TableData({name: "Name"})
  name: string;

  @TableData({name: "Email", cellSize: "large"})
  email: string;

  @TableData({name: "Phone", cellSize: "large"})
  phoneNumber: string;

  @TableData({name: "Date of Birth", cellSize: "large"})
  birthDate: string;
}

export class ContactsFragment extends ListTableDataSourceFragment<Contact, ContactsTableDataRow, Contacts> {

  private readonly actions: ActionBase[] = [
    ACTION_SPACE,
    new Action("New Contact", () => {
      EditContactHelper.addContact();
    }, AddOutlined)
      .setVariant("contained"),
  ];

  constructor(props: TableDataSourceFragmentProps, context: any) {
    super(props, context, Contacts.getInstance());
  }

  protected onCreateState(): TableDataSourceFragmentState {
    return {
      ...super.onCreateState(),
      title: "Contacts",
    };
  }

  protected styleFlags(): number {
    return PageFragment.STYLE_TOOLBAR_TYPE_FLAG;
  }

  protected getToolbar(toolbarModeId: string | null): React.ReactElement {
    if (toolbarModeId === "select") {
      const bases: ActionBase[] = [];
      const items = this.state.multiSelectItems as Contact[];
      if (items?.length === 1) {
        bases.push(new Action("Manage Contact", () => onManageContact(this.props.path, items[0]), ContactPageOutlined));
      }
      bases.push(new Action("Delete", () => {
      }, DeleteOutlined)
        .makeDestructive());
      return this.renderToolbarButtonsInToolbarContainer(bases);
    }
    return this.renderToolbarButtonsInToolbarContainerEx(this.actions);
  }

  createTableDataRow(): ContactsTableDataRow {
    return new ContactsTableDataRow();
  }

  applyTableDataToRow(data: Contact, content: ContactsTableDataRow): void {
    content.channel = data.channel;
    content.name = DisplayName(data.firstname, data.lastname);
    content.email = data.email;
    content.phoneNumber = data.phoneNumber;
    content.birthDate = DateUtil.formatDateTime(data.birthDate, FORMAT_SHOW_YEAR);
  }

  onTableDataSelected(data: Contact) {
    if (data.channel === ContactChannel.PATIENT) {
      BaseApp.CONTEXT.showTextDialog("Not editable", "Patient contacts are not editable in Vantage. Use myCare app to manage patients.", ACTION_OK);
      return;
    }
    EditContactHelper.editContact(data);
  }

  onTableCellChanged(data: Contact, cellId: string, value: any): void {
  }

  renderContent(): ReactElement {
    const data = this.loader.getListItems();
    return <TableDataContainer
      dataTotal={data.length}
      data={data}
      selectModeConfig={this.props.selectModeConfig ? {initialSelection: this.props.selectModeConfig.initialSelection} : null}
      source={this}
      multiSelectListener={this}/>;
  }
}